import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Content from 'components/Content';
import ToolsDetails from 'pages/ToolsDetails';
import UnderConstruction from 'pages/UnderConstruction';
import ToolsForm from '../components/toolsform';
import ToolsBUForm from '../components/toolsbuform';

const Depts = () => {
	const deptpath = '/bu'
	return (
		<Switch>
			<Route exact path={`${deptpath}/create`} component={ToolsBUForm} />
			<Route exact path={`${deptpath}/:id`} component={ToolsBUForm} />
			<Route component={UnderConstruction} />
		</Switch>
		
	);
};

export default Depts;
